(function () {
  function playVideo(video) {
    if (!video) return;
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    var playPromise = video.play();
    if (playPromise && playPromise.catch) playPromise.catch(function () {});
  }

  function setActiveMedia(videos, index) {
    videos.forEach(function (video, i) {
      var active = i === index;
      video.setAttribute('data-slide-active', active ? 'true' : 'false');
      if (active) {
        video.removeAttribute('aria-hidden');
        playVideo(video);
      } else {
        video.setAttribute('aria-hidden', 'true');
        if (!video.paused) video.pause();
      }
    });
  }

  function initAnatomy(root) {
    var videos = root.querySelectorAll('[data-anatomy-video]');
    var layers = root.querySelectorAll('[data-anatomy-layer]');
    if (!layers.length) return;

    var currentIndex = 0;
    layers.forEach(function (layer, i) {
      if (layer.classList.contains('is-active')) currentIndex = i;
    });
    setActiveMedia(videos, currentIndex);

    layers.forEach(function (layer) {
      layer.addEventListener('click', function () {
        var index = Number(layer.getAttribute('data-anatomy-layer'));
        if (Number.isNaN(index) || index === currentIndex) return;
        currentIndex = index;

        layers.forEach(function (l) {
          var active = Number(l.getAttribute('data-anatomy-layer')) === index;
          l.classList.toggle('is-active', active);
          var toggle = l.querySelector('[data-layer-toggle]');
          if (toggle) toggle.textContent = active ? '−' : '+';
        });

        setActiveMedia(videos, index);
      });
    });
  }

  function initFaq(root) {
    var tabs = root.querySelectorAll('[data-faq-tab]');
    var panels = root.querySelectorAll('[data-faq-panel]');

    function setFaqOpen(item, open) {
      item.classList.toggle('is-open', open);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-faq-tab');
        tabs.forEach(function (t) {
          t.classList.toggle('is-active', t.getAttribute('data-faq-tab') === target);
        });
        panels.forEach(function (panel) {
          var active = panel.getAttribute('data-faq-panel') === target;
          panel.classList.toggle('is-active', active);
          if (!active) {
            panel.querySelectorAll('.mattress-landing-faq__item.is-open').forEach(function (item) {
              setFaqOpen(item, false);
            });
          }
        });
      });
    });

    root.querySelectorAll('[data-faq-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('.mattress-landing-faq__item');
        var panel = trigger.closest('[data-faq-panel]');
        if (!item || !panel) return;
        var wasOpen = item.classList.contains('is-open');
        panel.querySelectorAll('.mattress-landing-faq__item.is-open').forEach(function (openItem) {
          setFaqOpen(openItem, false);
        });
        if (!wasOpen) setFaqOpen(item, true);
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-mattress-anatomy]').forEach(initAnatomy);
    document.querySelectorAll('[data-mattress-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  // Re-align hash anchors (e.g. #mattress-comparison from the PDP upsell)
  // once lazy content above has settled and shifted the layout.
  function scrollToHash() {
    if (!location.hash) return;
    var target;
    try {
      target = document.getElementById(decodeURIComponent(location.hash.slice(1)));
    } catch (e) {
      return;
    }
    if (!target || !target.closest('.kuala-mattress-landing')) return;
    // Jump first so the theme switches the header to its sticky state, then
    // align the section to where the sticky header group (announcement bar +
    // header) visually ends. The theme updates the header asynchronously,
    // so re-check a couple of times until it settles.
    function headerBottom() {
      var bottom = 0;
      document.querySelectorAll('.shopify-section-group-header-group').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.height && r.bottom > 0 && r.top < window.innerHeight / 2) bottom = Math.max(bottom, r.bottom);
      });
      return bottom;
    }
    function align(passesLeft) {
      var diff = target.getBoundingClientRect().top - headerBottom();
      if (Math.abs(diff) > 2) window.scrollBy(0, diff);
      if (passesLeft > 0) setTimeout(function () { align(passesLeft - 1); }, 300);
    }
    target.scrollIntoView({ block: 'start' });
    setTimeout(function () { align(2); }, 300);
  }

  if (document.readyState === 'complete') {
    scrollToHash();
  } else {
    window.addEventListener('load', scrollToHash);
  }
})();
